// extracted by mini-css-extract-plugin
module.exports = {"DarkBannerAfter":"TopBanner_DarkBannerAfter__sIyqz","BannerDark":"TopBanner_BannerDark__cw3AE"};